module.exports = __webpack_public_path__ + "static/slide-3-7cea062e8629c4d7441bc45caa823c12.jpg";